<template>
  <div>
    <!-- General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.fidelities')"></general-top-bar> -->

    <!-- Navigation Buttons -->
    <div id="outer-container">
      <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
        <div class="card-content">
          <div class="clearfix row pad-lf-10 pad-rg-10">
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isCompanyLocations }"
              @click="openTab('companyLocations')"
            >{{$t('settingsPages.companyLocations')}}</a>

            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isLocationGroups }"
              @click="openTab('locationGroups')"
            >{{$t('settingsPages.locationGroups')}}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Contents -->
    <div v-if="isCompanyLocations">
      <locations
        v-on:setSelectedTab="setSelectedTab"
      ></locations>
    </div>

    <div v-if="isLocationGroups">
      <template v-if="selectedLocationGroups !== false">
        <location-groups-form
          :callback="updateLocationGroups"
          :locId="selectedLocationGroups"
        ></location-groups-form>
      </template>
      <template v-else>
        <location-groups
          ref="LocationGroups"
          :isLocationGroups="isLocationGroups"
          :callback="getLocationGroups"
        ></location-groups>
      </template>
    </div>
  </div>
</template>
<script>
import Locations from './Locations/Location.vue'
import LocationGroups from './LocationGroups/LocationGroups.vue'
import LocationGroupsForm from './LocationGroups/LocationGroupsForm.vue'
// import GeneralTopBar from './GeneralTopBar.vue'

export default {
  components: {
    Locations,
    LocationGroups,
    LocationGroupsForm
    // GeneralTopBar
  },
  data () {
    return {
      // Tab-uri active
      isCompanyLocations: true,
      isLocationGroups: false,

      // Selectează un element pentru formularul de grup locații
      selectedLocationGroups: false
    }
  },
  created () {
    // Setează tab-ul implicit
    console.log('Created SettingsLocations.vue')
  },
  methods: {
    openTab (tab) {
      this.isCompanyLocations = false
      this.isLocationGroups = false

      switch (tab) {
        case 'companyLocations':
          this.isCompanyLocations = true
          break
        case 'locationGroups':
          this.isLocationGroups = true
          // forțează requestul în copil
          this.$nextTick(() => {
            if (this.$refs.LocationGroups) {
              this.$refs.LocationGroups.getData()
            }
          })
          break
      }
    },

    getLocationGroups (id) {
      this.selectedLocationGroups = id
    },

    updateLocationGroups () {
      this.selectedLocationGroups = false
      if (this.$refs.LocationGroups) {
        this.$refs.LocationGroups.getData()
      }
    },

    setSelectedTab (tab) {
      // Poți seta tab-ul activ din copil
      this.openTab(tab)
    }
  }
}
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsLocations.vue